import { CALL_API } from "../../../middlewares/api";

export const LOAN_NOTE_GET_REQUEST = "LOAN_NOTE_GET_REQUEST";
export const LOAN_NOTE_GET_SUCCESS = "LOAN_NOTE_GET_SUCCESS";
export const LOAN_NOTE_GET_ERROR = "LOAN_NOTE_GET_ERROR";

export function get_loan_notes_by_id(id) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/loans/notes?loanId=" + id,
      method: "GET",
      additionalData: id,
      types: [
        LOAN_NOTE_GET_REQUEST,
        LOAN_NOTE_GET_SUCCESS,
        LOAN_NOTE_GET_ERROR,
      ],
      authenticatedRequest: true,
    },
  };
}
